import { ALLOWED_FORM_FIELDS_FOR_DIRECT_BOOKING_LIST } from "@Modules/modals/components/UserDetails/FormData";

/**
 * Checks if all user details form fields are allowed for direct booking based on a predefined set of allowed fields.
 *
 * @param {string[]} userDetailsFormFields - An array of user details form fields to check.
 * @returns {boolean} - Returns true if all user details fields are allowed for direct booking; otherwise, returns false.
 */
export const getAreAllUserDetailsFieldsAllowedForDirectBooking = (
    userDetailsFormFields: string[]
) => {
    return !userDetailsFormFields.some(
        formField => !ALLOWED_FORM_FIELDS_FOR_DIRECT_BOOKING_LIST.has(formField)
    );
};
